import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Alert
} from '@mui/material';

const AperturaCajaDialog = ({ open, onClose, onSave, filiales = [], idFilialDefault = 1, trabajadores = [] }) => {
    const [idFilial, setIdFilial] = useState(idFilialDefault);
    const [codigo, setCodigo] = useState('');
    const [nombre, setNombre] = useState('');
    const [montoFondoFijo, setMontoFondoFijo] = useState(500);
    const [idResponsable, setIdResponsable] = useState('');
    const [observaciones, setObservaciones] = useState('');

    useEffect(() => {
        if (idFilialDefault > 0) {
            setIdFilial(idFilialDefault);
        }
        setCodigo(`CCH-${idFilialDefault}-${new Date().getFullYear()}`);
        setNombre(`Caja Chica Principal - ${filiales.find((f) => f.id === idFilialDefault)?.nombre || 'Sede'}`);
        if (trabajadores.length > 0 && !idResponsable) {
            setIdResponsable(trabajadores[0].idTrabajador || trabajadores[0].id);
        }
    }, [idFilialDefault, open, filiales, trabajadores]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (Number(montoFondoFijo) <= 0) {
            alert('El monto del fondo fijo debe ser mayor a 0.');
            return;
        }

        const model = {
            idFilial: Number(idFilial),
            codigo: codigo.trim() || `CCH-${idFilial}-${Date.now() % 1000}`,
            nombre: nombre.trim() || 'Fondo Fijo Caja Chica',
            montoFondoFijo: Number(montoFondoFijo),
            saldoDisponible: Number(montoFondoFijo),
            idResponsable: Number(idResponsable || (trabajadores[0]?.idTrabajador || 1)),
            observaciones: observaciones.trim()
        };

        onSave(model);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ fontWeight: 'bold', color: '#1f2937' }}>
                Apertura de Caja Chica (Fondo Fijo)
            </DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent dividers>
                    <Alert severity="info" sx={{ mb: 2 }}>
                        La apertura inicial generará el primer asiento de ingreso por el monto del Fondo Fijo asignado a la filial.
                    </Alert>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small" required>
                                <InputLabel>Filial / Sede</InputLabel>
                                <Select
                                    value={idFilial}
                                    onChange={(e) => {
                                        setIdFilial(e.target.value);
                                        const nomF = filiales.find((f) => f.id === e.target.value)?.nombre || '';
                                        setNombre(`Caja Chica Principal - ${nomF}`);
                                    }}
                                    label="Filial / Sede"
                                >
                                    {filiales.filter((f) => f.id > 0).map((f) => (
                                        <MenuItem key={f.id} value={f.id}>
                                            {f.nombre}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Código Identificador"
                                value={codigo}
                                onChange={(e) => setCodigo(e.target.value)}
                                placeholder="Ej: CCH-TAC-001"
                                fullWidth
                                size="small"
                                required
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label="Nombre descriptivo de la Caja"
                                value={nombre}
                                onChange={(e) => setNombre(e.target.value)}
                                fullWidth
                                size="small"
                                required
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Monto Fondo Fijo (S/)"
                                type="number"
                                inputProps={{ min: 1, step: '10' }}
                                value={montoFondoFijo}
                                onChange={(e) => setMontoFondoFijo(e.target.value)}
                                fullWidth
                                size="small"
                                required
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small" required>
                                <InputLabel>Trabajador Responsable</InputLabel>
                                <Select
                                    value={idResponsable}
                                    onChange={(e) => setIdResponsable(e.target.value)}
                                    label="Trabajador Responsable"
                                >
                                    {trabajadores.map((t) => (
                                        <MenuItem key={t.idTrabajador || t.id} value={t.idTrabajador || t.id}>
                                            {t.nombres} ({t.cargo || 'Personal'})
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label="Observaciones Iniciales"
                                value={observaciones}
                                onChange={(e) => setObservaciones(e.target.value)}
                                multiline
                                rows={2}
                                fullWidth
                                size="small"
                                placeholder="Indicar resolución, memorando o directiva de asignación..."
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={onClose} color="inherit">
                        Cancelar
                    </Button>
                    <Button type="submit" variant="contained" color="primary">
                        Aperturar Caja
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default AperturaCajaDialog;
